import api from '../api/axios';
import { AccionPostulacion, Postulacion } from '../types/postulacion';

export const postulacionService = {
  /** Solicitudes de un tema. Solo el guía/coguía o el coordinador pueden verlas. */
  list: async (temaId: number): Promise<Postulacion[]> => {
    const { data } = await api.get<Postulacion[]>(`temas/${temaId}/postulaciones/`);
    return data;
  },

  /** Postulaciones pendientes que me toca resolver (soy guía/coguía del tema).
   *  `todas` pide las de todo el sistema; el backend solo se lo permite al coordinador. */
  porResolver: async (todas = false): Promise<Postulacion[]> => {
    const { data } = await api.get<Postulacion[]>('me/postulaciones/', { params: todas ? { todas: 1 } : undefined });
    return data;
  },

  /** El estudiante postula al tema. */
  postular: async (temaId: number, mensaje = ''): Promise<Postulacion> => {
    const { data } = await api.post<Postulacion>(`temas/${temaId}/postulaciones/`, { mensaje });
    return data;
  },

  /** El guía acepta o rechaza. Aceptar rechaza el resto y asigna el tema. */
  resolver: async (id: number, accion: AccionPostulacion, motivo = ''): Promise<Postulacion> => {
    const { data } = await api.post<Postulacion>(`postulaciones/${id}/resolver/`, { accion, motivo });
    return data;
  },

  /** El estudiante retira su propia postulación (mientras siga pendiente). */
  retirar: async (id: number): Promise<void> => {
    await api.delete(`postulaciones/${id}/`);
  },
};
